import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../assets/style/Welcome.css';

const WelcomeModal = ({ welcomeData, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';

    useEffect(() => {
        const timer = setTimeout(() => {
            if (welcomeData && welcomeData.link) {
                setIsVisible(true);
                setTimeout(() => setShowModal(true), 100);
            }
        }, 60000);

        return () => clearTimeout(timer);
    }, [welcomeData]);

    const handleClose = () => {
        setShowModal(false);
        setTimeout(() => {
            setIsVisible(false);
            if (onClose) onClose();
        }, 300);
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    const getYouTubeEmbedUrl = (url) => {
        if (!url) return '';

        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        if (match && match[2].length === 11) {
            return `https://www.youtube.com/embed/${match[2]}?autoplay=0&rel=0&modestbranding=1`;
        }

        return url;
    };

    const renderContent = () => {
        if (!welcomeData || !welcomeData.link) return null;

        const { type, link, title, description } = welcomeData;

        if (type === 'youtube') {
            const embedUrl = getYouTubeEmbedUrl(link);
            return (
                <div className="welcome-modal__video-container">
                    <iframe
                        src={embedUrl}
                        title={title || t('welcome.videoTitle', 'Welcome Video')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="welcome-modal__video"
                    />
                </div>
            );
        } else if (type === 'image' || link.match(/\.(jpeg|jpg|gif|png)$/i)) {
            return (
                <div className="welcome-modal__image-container">
                    <img
                        src={link}
                        alt={title || t('welcome.imageAlt', 'Welcome Image')}
                        className="welcome-modal__image"
                    />
                </div>
            );
        } else {
            return (
                <div className="welcome-modal__content-placeholder">
                    <p>{t('welcome.contentNotSupported', 'Content type not supported')}</p>
                </div>
            );
        }
    };

    if (!isVisible) return null;

    return (
        <div
            className={`welcome-modal__overlay ${showModal ? 'welcome-modal__overlay--show' : ''}`}
            onClick={handleOverlayClick}
            dir={isRTL ? 'rtl' : 'ltr'}
        >
            <div className={`welcome-modal ${showModal ? 'welcome-modal--show' : ''} ${isRTL ? 'welcome-modal--rtl' : ''}`}>
                <div className="welcome-modal__header">
                    <h2 className="welcome-modal__title">
                        {welcomeData?.title || t('welcome.defaultTitle', `Welcome to Arab ${process.env.REACT_APP_legalProjectTitle} `)}
                    </h2>
                    <button
                        className="welcome-modal__close"
                        onClick={handleClose}
                        aria-label={t('welcome.close', 'Close')}
                        type="button"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M18 6L6 18M6 6l12 12"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                </div>

                <div className="welcome-modal__body">
                    {renderContent()}

                    {welcomeData?.description && (
                        <div className="welcome-modal__description">
                            <p>{welcomeData.description}</p>
                        </div>
                    )}
                </div>


            </div>
        </div>
    );
};

export default WelcomeModal;